module.exports = __webpack_public_path__ + "img/logo-fifalotto-white4-nv24.dd40efd5.png";